export const getPoAllProofsUploaded = (purchaseOrder = {}) => Boolean(
  purchaseOrder?.allProofsUploaded ?? purchaseOrder?.proofSummary?.allProofsUploaded ?? false
);
